import { Capacitor } from '@capacitor/core';

import { INAPP_BROWSER_TOOLBAR_COLOR } from '@/constants';

export default {
  updated(el: HTMLElement) {
    // Get all anchor tags inside this element
    const links: NodeListOf<HTMLAnchorElement> = el.querySelectorAll('a[href]');

    links.forEach((link) => {
      const href = link.getAttribute('href');
      if (!href) {
        return;
      }

      const isExternal =
        href.startsWith('http') &&
        !href.includes(window.location.host) &&
        !href.startsWith('capacitor://') &&
        !href.startsWith('http://localhost') &&
        !href.startsWith('https://localhost');

      if (!isExternal) {
        return;
      }

      // Always ensure web safety
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      // --- Native behavior (Capacitor) ---
      if (Capacitor.isNativePlatform()) {
        // Prevent duplicate listeners on re-renders
        if (link.dataset.capListenerAttached === 'true') {
          return;
        }

        // Store original href and disable normal navigation
        link.dataset.href = href;
        link.setAttribute('href', '#');

        link.addEventListener('click', async (e: Event) => {
          e.preventDefault();
          e.stopImmediatePropagation();

          const url = link.dataset.href;
          if (!url) {
            return;
          }

          try {
            const { Browser } = await import('@capacitor/browser');
            console.log('Opening external link in in-app browser:', url);
            await Browser.open({
              url,
              toolbarColor: INAPP_BROWSER_TOOLBAR_COLOR,
            });
          } catch (err) {
            console.error('Failed to open link via Capacitor Browser:', err);
          }
        });

        // Mark this link so we don’t attach the listener again
        link.dataset.capListenerAttached = 'true';
      }
    });
  },
};
